module.exports = __webpack_public_path__ + "img/sch1-gift1-info.9e1f7996.png";